import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { AppPaths } from '@ftr/routing-paths'
import { ForbiddenComponent, NotFoundComponent } from '@ftr/ui-core'
import { CourtSystemForbiddenComponent } from '@ftr/ui-court-system'
import { DesktopLoginSplashComponent } from '@ftr/ui-desktop'
import {
  ExternalLoginModule,
  LoggedInGuard,
  LoginModule,
  RedirectSitePortalToHomeIfPublicNavigationGuard,
} from '@ftr/ui-user'
import { CourtSystemForbiddenPage } from './court-system-forbidden.page'
import { DesktopLoginSplashPage } from './desktop-login-splash.page'
import { DesktopUpdateSplashPage } from './desktop-update-splash.page'
import { ExternalLoginPage } from './external-login.page'
import { ForbiddenPage } from './forbidden.page'
import { LoginPage } from './login.page'
import { LogoutPage } from './logout.page'

/**
 * Auth and public shell routes shared by ftr-public, ftr-web (courts) and ftr-admin
 * (login, logout, help-adjacent public pages).
 */
@NgModule({
  imports: [
    LoginModule,
    ForbiddenComponent,
    NotFoundComponent,
    ExternalLoginModule,
    CourtSystemForbiddenComponent,
    DesktopLoginSplashComponent,
    CourtSystemForbiddenPage,
    RouterModule.forChild([
      {
        path: AppPaths.Login,
        component: LoginPage,
        canMatch: [RedirectSitePortalToHomeIfPublicNavigationGuard],
        canActivate: [LoggedInGuard],
        data: {
          title: 'Log In',
          hideSideNav: true,
        },
      },
      {
        path: AppPaths.DesktopLoginSplash,
        component: DesktopLoginSplashPage,
        canMatch: [RedirectSitePortalToHomeIfPublicNavigationGuard],
        data: {
          title: 'Launching For The Record',
        },
      },
      {
        path: AppPaths.DesktopUpdateSplash,
        component: DesktopUpdateSplashPage,
        canMatch: [RedirectSitePortalToHomeIfPublicNavigationGuard],
        data: {
          title: 'App Version Out of Date',
        },
      },
      {
        path: AppPaths.Logout,
        component: LogoutPage,
        canMatch: [RedirectSitePortalToHomeIfPublicNavigationGuard],
      },
      {
        path: AppPaths.Forbidden,
        component: ForbiddenPage,
        canMatch: [RedirectSitePortalToHomeIfPublicNavigationGuard],
        data: {
          hideSideNav: true,
        },
      },
      {
        path: AppPaths.NotFound,
        component: NotFoundComponent,
        canMatch: [RedirectSitePortalToHomeIfPublicNavigationGuard],
      },
      {
        path: AppPaths.ExternalLogin,
        component: ExternalLoginPage,
        canMatch: [RedirectSitePortalToHomeIfPublicNavigationGuard],
      },
      {
        path: AppPaths.CourtSystemForbidden,
        component: CourtSystemForbiddenPage,
        canMatch: [RedirectSitePortalToHomeIfPublicNavigationGuard],
      },
    ]),
  ],
  declarations: [LoginPage, DesktopLoginSplashPage, LogoutPage, ForbiddenPage, ExternalLoginPage],
  exports: [RouterModule],
})
export class SharedAuthRoutesModule {}
